import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { toGetVideoAlbum } from "../../../apis/actions/photoVideos.actions";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import MenuItemLayout from "./MenuItemLayout";
import Loader from "../../../biblio/Loader/Loader";
import PreviewMedia from "../../../biblio/PreviewMedia/PreviewMedia";

const VideoAlbum = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { videos, loading } = useSelector(
    (state: RootState) => state.photoVideo
  );

  useEffect(() => {
    dispatch(toGetVideoAlbum());
  }, [dispatch]);

  if (loading) return <Loader />;
  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="المركز الإعلامي"
      subTitle={"الفيديوهات"}
      urlImage={banner}
      className="takaful--our-story"
    >
      <PreviewMedia
        mediaItems={videos}
        loading={loading}
        itemPerPage={6}
        isVideo={true}
      />
    </MenuItemLayout>
  );
};

export default VideoAlbum;
